import { render, staticRenderFns } from "./Project-report.vue?vue&type=template&id=464bfb82"
import script from "./Project-report.vue?vue&type=script&lang=js"
export * from "./Project-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports